import { Button, Tooltip } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { useUnit } from 'effector-react';
import { downloadSectorsDataFx } from '../../models/sectorsModel/index.js';

function DownloadFilteredButton({ onDownload }) {
  const loading = useUnit(downloadSectorsDataFx.pending);

  return (
    <Tooltip title="Скачать выгрузку по примененным фильтрам" placement="right">
      <Button
        type={'primary'}
        ghost
        icon={<DownloadOutlined />}
        onClick={() => onDownload()}
        loading={loading}
      />
    </Tooltip>
  );
}

export default DownloadFilteredButton;
